import { Link } from "@tanstack/react-router";
import { IconHistory, IconPrinter, IconShieldCheck } from "@tabler/icons-react";
import {
  Badge,
  EstadoBadge,
  Group,
  IconAction,
  PageHeader,
  Stack,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui";
import type { SolicitudDetalle } from "@/lib/types";

export function DetalleHeader({ sol }: { sol: SolicitudDetalle }) {
  return (
    <PageHeader
      title={`Solicitud ${sol.folio}`}
      description={
        <Group gap={6}>
          <Text size="sm" c="dimmed">{sol.tipo ?? "—"} · {sol.subtipo ?? "—"}</Text>
          <Text size="sm" c="dimmed">·</Text>
          <Text size="xs" c="dimmed">
            Última actividad{" "}
            {new Date(sol.fechaUltimoEvento).toLocaleString("es-MX", {
              day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
            })}
          </Text>
        </Group>
      }
      breadcrumbs={[
        { label: "Inicio", href: "/dashboard" },
        { label: "Solicitudes", href: "/solicitudes" },
        { label: sol.folio },
      ]}
      actions={
        <>
          <Tooltip>
            <TooltipTrigger asChild>
              <Link
                to="/solicitudes/$id/historial"
                params={{ id: sol.id }}
                aria-label="Historial"
                className="print-hide inline-flex size-9 shrink-0 items-center justify-center rounded-md border border-border bg-background transition-colors hover:bg-muted"
              >
                <IconHistory size={16} />
              </Link>
            </TooltipTrigger>
            <TooltipContent>Ver historial de cambios (Temporal Tables)</TooltipContent>
          </Tooltip>
          <IconAction
            label="Imprimir o exportar a PDF"
            variant="default"
            className="print-hide"
            onClick={() => window.print()}
          >
            <IconPrinter size={16} />
          </IconAction>
          <Stack gap={4} align="flex-end">
            <EstadoBadge estado={sol.estado} size="md" />
            {sol.enviadaAContabilizacion && (
              <Badge variant="light" color="exito" size="xs">
                <IconShieldCheck size={10} className="mr-1" /> En contabilización
              </Badge>
            )}
          </Stack>
        </>
      }
    />
  );
}
